import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AssetDto, GalleryAccessLevel, GalleryDto } from '@picflow/types';
import { ShareAssetDialogComponent } from 'src/app/account/dialogs/share-asset-dialog/share-asset-dialog.component';
import { AssetService } from 'src/app/services/asset.service';
import { DialogService } from 'src/app/services/dialog.service';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { StateService } from 'src/app/services/state.service';
import { AvatarPipe } from 'src/app/shared-extra/pipes/avatar.pipe';
import { ViewProfileMenuComponent } from 'src/app/view-gallery/components/view-profile-menu/view-profile-menu.component';
import { GuestProfileDialogComponent } from 'src/app/view-gallery/dialogs/guest-profile-dialog/guest-profile-dialog.component';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { AssetPageMetaComponent } from '../asset-page-meta/asset-page-meta.component';
import { DownloadSizeSelectionComponent } from '../download-size-selection/download-size-selection.component';
import { IosDownloadContextComponent } from '../ios-download-context/ios-download-context.component';

@Component({
  selector: 'app-asset-header',
  templateUrl: './asset-header.component.html',
  styleUrls: ['./asset-header.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    NgIf,
    ButtonDirective,
    TooltipDirective,
    SvgComponent,
    AssetPageMetaComponent,
    ContextMenuComponent,
    DownloadSizeSelectionComponent,
    IosDownloadContextComponent,
    TranslatePipe,
    ViewProfileMenuComponent,
    AvatarPipe,
    AsyncPipe,
    AvatarComponent,
  ],
})
export class AssetHeaderComponent {
  @ViewChild('anonymousGuestInfo') anonymousGuestInfoEl: ContextMenuComponent;
  @Input() asset: AssetDto;
  @Input() sideMenuOpen: boolean;
  @Input() gallery: GalleryDto;
  @Input() embedMode: boolean;
  @Input() clientMode: boolean;
  @Input() accessLevel: GalleryAccessLevel;
  @Input() activeIndex: number;
  @Input() thumbnailBarOpen: boolean;
  @Input() previewWidth: number;
  @Output() onClose = new EventEmitter();
  @Output() onShowInfo = new EventEmitter();
  @Output() onThumbnailBarOpen = new EventEmitter();
  iosDownloadMenu: boolean;

  constructor(
    private assetService: AssetService,
    public featureFlags: FeatureFlagsService,
    private dialog: DialogService,
    public state: StateService
  ) {}

  close() {
    this.onClose.emit('');
  }

  download(size?: number) {
    this.assetService.downloadAssetVersion(
      this.asset.version_data,
      this.asset.type,
      this.gallery.id,
      this.asset.watermark_enabled,
      size
    );
  }

  openShareDialog() {
    this.dialog.open(ShareAssetDialogComponent, {
      gallery: this.gallery,
      asset: this.asset,
    });
  }

  async openGuestProfileDialog() {
    await this.dialog.open(GuestProfileDialogComponent, { gallery: this.gallery });
  }
}
